<div class="d-flex flex-column flex-sm-row">
  <div class="w-100 mr-sm-2"><sms-bundle-balance [company]="company"></sms-bundle-balance></div>
  <div class="w-100 ml-sm-2"><sms-fraud-limits [company]="company"></sms-fraud-limits></div>
</div>
<span class="vox-heading-3" translate>company.sms.title</span><br>
<div class="add-sender">
  <button class="vox-btn vox-btn-secondary" (click)="addNewSender()" translate>company.sms.add-button</button>
</div>
<div class="vox-table company-sender">
  <table>
    <thead>
      <tr>
        <td translate>company.sms.sender</td>
        <td translate>company.sms.sender-type</td>
        <td translate>company.sms.actions</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <ng-container *ngFor="let s of senders">
        <tr>
          <td>{{ s.type === 'long_number' ? (s.name?.startsWith('+') ? s.name : '+' + s.name) : s.name }}</td>
          <td>{{s.type === 'long_number' ? 'Phone number' : 'Alphanumeric'}}</td>
          <td class="sender-data-row__actions">
            <div class="sender-data-row__actions--wrapper">
              <button class="vox-btn btn btn-warning" (click)="editSender(s)" [ngbTooltip]="'company.sms.info.edit' | translate">
                <i class="icon-small-edit"></i>
              </button>
              <button class="vox-btn btn btn-danger" (click)="deleteSender(s)" [ngbTooltip]="'company.sms.info.delete' | translate">
                <i class="icon-small-delete"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of [1,2,3,4]">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && senders.length === 0">
      <tr>
        <td colspan="3" translate>company.sms.empty</td>
      </tr>
    </tbody>
  </table>
</div>